import { addDays } from 'date-fns/addDays'
import { format } from 'date-fns/format'

import { DATEFORMAT_SHORT, EPOCH } from '@/defs/date'

export const formatDateFromDaysSinceEpoch = (days: number, formatStr: string = DATEFORMAT_SHORT) =>
  format(addDays(EPOCH, days), formatStr)
